import m from "mithril";
import DarkMode from "../components/dark-mode.jsx";
/** @typedef {import('mithril').Vnode} Vnode */

const RootTemplate = {
  view: (/** @type {Vnode} */ vnode) => {
    return (
      <main>
        <header>
          <div class="toggle-container">
            <DarkMode />
          </div>
          <div class="header-content">
            <h1>vm-kit</h1>
            <p>
              The Linux kernel of hypervisors. open, flexible, and built to
              last.
            </p>
            <m.route.Link href="/" style="padding-right: 15px">
              home
            </m.route.Link>
            <m.route.Link href="/posts"> posts </m.route.Link>
          </div>
        </header>

        {vnode.children}

        <footer>
          <div>
            <p>© 2025 vm-kit.</p>
          </div>
        </footer>
      </main>
    );
  },
};

export default RootTemplate;
